export default __webpack_public_path__ + "static/media/car_with_line.868e010b.png";